module.exports = __webpack_public_path__ + "img/wheelDetailExample.e2904b52.svg";